import { MicroviewCommunicationChannel } from '../MicroviewCommunicationChannel';

export class FeatureFlagChannel extends MicroviewCommunicationChannel<{ featureFlag: string }, { featureFlagState: boolean }> {
  public namespace: string = 'VPC.FeatureFlags';
  public name: string = 'FeatureFlagChannel';
}
